import { NodeProps } from '@xyflow/react';
import { memo } from 'react';

import { NodeModel } from '@diagram/model/node.model';

const SwimlaneGroup: React.FC<NodeProps<NodeModel>> = memo(
  ({ selected, width, height }: NodeProps<NodeModel>) => {
    const borderColor = selected ? '#0C5C65' : 'gray';

    return (
      <div
        className="relative group border-2"
        style={{ width, height, borderColor, zIndex: 10 }}
      ></div>
    );
  }
);

SwimlaneGroup.displayName = 'SwimlaneGroup';

export default SwimlaneGroup;
